import React from "react";
import BudgetMaster from './Budget_Master';

const BdgtMastApp = () =>{
    return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Budget / Sub-Budget Master</h5>
          </div>
        </div>
        <BudgetMaster />
      </div>
    </div >
  );
};

export default BdgtMastApp;
